<template>
  <div class="player">
    <div class="top">
      <div class="left fl">
        <i class="back fl" @click="goBack">
          <img src="../assets/images/back.png" alt />
        </i>
        <h2 class="title fl">课程名称：{{dataInfo.courseName}}</h2>
      </div>
      <div class="photo cl fr">
        <img src="../assets/images/person.png" alt />
      </div>
    </div>
    <div class="container">
      <div class="video fl">
        <div id="player"></div>
        <!-- <player-video></player-video> -->
      </div>
      <div class="videoList fr">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item
            :title="item.ccName"
            :name="i"
            v-for="(item,i) in dataInfo.catalog"
            :key="i"
          >
            <ul class="list">
              <li v-for="(sub,j) in item.subCatalog" :key="j" @click="videoList(sub.ccId)">
                <i></i>
                <span>{{sub.ccName}}</span>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>
<script src="//player.polyv.net/script/player.js"></script>
<script>
import playerVideo from "../components/player";
import http from "../api/module";

export default {
  name: "detailPlayer",
  data() {
    return {
      activeNames: ["1"],
      dataInfo: {},
      configInfo: {},
      ccId: "",
      videoId: "",
      player: null
    };
  },
  components: {
    playerVideo
  },
  mounted() {
    this.getDetail();
    this.getVideo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleChange(val) {
      console.log(val);
    },
    videoList(ccId) {
      this.ccId = ccId;
      this.getVideoTime(this.ccId);
    },
    // 获取课程详情
    getDetail() {
      http
        .getCourseDetail({
          courseId: this.$route.query.courseId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.dataInfo = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    // 获取视频配置信息
    getVideo() {
      http
        .getVideoConfig({
          courseId: this.$route.query.courseId
        })
        .then(data => {
          if ( data.data.code == "200" || data.data.success == true) {
            this.configInfo = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    // 获取视频ID及最后播放时间点
    getVideoTime(ccId) {
      http
        .getVideoId({
          ccId: ccId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.videoId = data.data.data.videoId;
            console.log(this.videoId);
            // this.configInfo = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    playerStart() {
      // this.player = 
    }
  }
};
</script>
<style lang="less" scoped>
.player {
  height: 100%;
}
.top {
  height: 60px;
  line-height: 60px;
  .back {
    width: 80px;
    text-align: center;
    cursor: pointer;
    transition: 0.3s;
    margin-right: 20px;
    &:hover {
      background: #eee;
    }
    img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }
  }
  .title {
    font-size: 20px;
    font-weight: normal;
  }
  .photo {
    height: 100%;
    position: relative;
    img {
      width: 46px;
      height: 46px;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
    }
  }
}
.container {
  width: 100%;
  height: calc(100% - 60px);
  .video {
    width: 80%;
    height: 100%;
    background: #000;
  }
  .videoList {
    width: 20%;
    height: 100%;
    overflow: auto;
    background: #000000;
    padding-left: 20px;
    border-left: 2px solid #383636;
    white-space: nowrap;
    .list {
      li {
        line-height: 40px;
        font-size: 16px;
        padding: 0 16px;
        cursor: pointer;
        transition: 0.3s;
        &:hover {
          color: #00c9a1;
        }
        i {
          display: inline-block;
          vertical-align: middle;
          height: 14px;
          width: 14px;
          margin-right: 10px;
          background: url("../assets/images/willStudy.png") no-repeat center;
        }
        .studing {
          background: url("../assets/images/studing.png") no-repeat center;
        }
        .studyOver {
          background: url("../assets/images/studyOver.png") no-repeat center;
        }
      }
    }
  }
  /deep/.el-collapse-item__header,
  /deep/.el-collapse-item__wrap {
    font-size: 18px;
    line-height: 46px;
    background: #000;
    color: #ffffff !important;
    border-bottom: none;
  }
  /deep/.el-collapse {
    border-top: none;
  }
  /deep/.el-collapse-item__content {
    color: #fff;
    padding-bottom: 10px !important;
  }
}
</style>